/* Reopen Shopify's configured consent modal without navigating to the policies index. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-astra-cookie-preferences]');
  if (!link || !window.privacyBanner?.showPreferences) return;
  event.preventDefault();
  Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {
    window.location.assign(link.href);
  });
});
